import React from 'react';
import { CaseEvidenceTable2 } from '../../case-evidence-table/case-evidence-table2';

import * as editorIssues from '../../common/editor-issues';
import classnames from 'classnames';
import { cmxTypeguards } from '@codametrix/ui-common';
/**
 * React component that displays a build body
 * @param medicalCode
 * @param panelActivations
 * @param onFeatureSelection
 * @returns
 */
export const BuildBody = (
  medicalCode: CMxCommonApp.ChargeSessionCode | CMxCommonApp.ZippedCodeBlock,
  techTransaction: CMxCommonApp.TechTransaction,
  panelActivations: CMxCommonApp.PanelActivations,
  codeEdits: CMxCommonApp.CodeEditInputs,
  onFeatureSelection: (selection: CMxCommonApp.ChargeSessionSelection) => void
) => {
  const styleClasses = [`code-header`, `code-body`, 'transaction-body'];
  if (cmxTypeguards.isZippedCodeBlock(medicalCode)) {
    return <></>;
  } else {
    const sessionCode = medicalCode as CMxCommonApp.ChargeSessionCode;
    const messages = codeEdits[sessionCode.code]
      ? editorIssues.formatEditGroup(codeEdits[sessionCode.code], 0)
      : false;
    return (
      <div className={classnames(styleClasses)}>
        <div className="case-evidence-container">
          {messages && (
            <div className="col-artifacts message-wrap">
              <div className="col-code"></div>
              <div className="col-artifacts col-messages">{messages}</div>
            </div>
          )}
          <CaseEvidenceTable2
            panelActivations={panelActivations}
            onFeatureSelection={onFeatureSelection}
            chargeSessionCode={sessionCode}
            techTransaction={techTransaction}
          />
        </div>
      </div>
    );
  }
};
